module.exports = __webpack_public_path__ + "img/attention.3fd2b6ca.svg";